import { getPreviousDate, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { marketAnalyzerCurrentPeriod, marketAnalyzerEndDate } from "../../@signals"


export const PricingMarketAnalyzerDateRange = [
    {
        label: "Yesterday",
        value: () => { return [getPreviousDate({ days: 1 }, marketAnalyzerEndDate.value), getPreviousDate({ days: 1 }, marketAnalyzerEndDate.value)] },
        placement: "left",
        onFocus: () => marketAnalyzerCurrentPeriod.value = DATE_PERIODS.YESTERDAY
    }, {
        label: "Last 7 Days",
        value: () => { return [getPreviousDate({ days: 6 }, marketAnalyzerEndDate.value), stringToDate(marketAnalyzerEndDate.value)] },
        placement: "left",
        onFocus: () => marketAnalyzerCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
    }, {
        label: "Last 30 Days",
        value: () => { return [getPreviousDate({ days: 29 }, marketAnalyzerEndDate.value), stringToDate(marketAnalyzerEndDate.value)] },
        placement: "left",
        onFocus: () => marketAnalyzerCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
    }, {
        label: "Last Month",
        value: () => {
            return [
                getPreviousDate({ months: 1 }, new Date(stringToDate(marketAnalyzerEndDate.value).setDate(1))),
                getPreviousDate({ days: 1 },  new Date(stringToDate(marketAnalyzerEndDate.value).setDate(1)))
            ]
        },
        placement: "left",
        onFocus: () => marketAnalyzerCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
    }
]